const RICOS_VERSION = "10.169.2";
export {
  RICOS_VERSION
};
//# sourceMappingURL=version.js.map
